import { z } from 'zod';

/** Voto do viajante numa resposta do AGENTE (web-chat 👍/👎). */
export const MessageFeedbackValueSchema = z.enum(['up', 'down']);
export type MessageFeedbackValue = z.infer<typeof MessageFeedbackValueSchema>;

/** Motivos do 👎 — enum fechado (analytics/Langfuse só recebem códigos). */
export const MessageFeedbackReasonSchema = z.enum([
  'wrong_info',
  'incomplete',
  'misunderstood',
  'bad_options',
  'too_slow',
  'other',
]);
export type MessageFeedbackReason = z.infer<typeof MessageFeedbackReasonSchema>;

/**
 * Corpo do POST (web-chat → BFF → conversation). `value: null` = remover o voto.
 * `reasons`/`comment` só fazem sentido com 'down' — o refine rejeita o resto.
 * `comment` é PII: fica só no Mongo, nunca é ecoado ao cliente.
 */
export const MessageFeedbackRequestSchema = z
  .object({
    value: MessageFeedbackValueSchema.nullable(),
    reasons: z.array(MessageFeedbackReasonSchema).max(6).optional(),
    comment: z.string().trim().min(1).max(500).optional(),
  })
  .strict()
  .refine((b) => b.value === 'down' || (b.reasons === undefined && b.comment === undefined), {
    message: 'reasons/comment only with value "down"',
  });
export type MessageFeedbackRequest = z.infer<typeof MessageFeedbackRequestSchema>;

/** Estado ecoado/projetado por mensagem (sessão, history, resposta do POST). */
export const MessageFeedbackSchema = z
  .object({
    messageId: z.string().min(1),
    value: MessageFeedbackValueSchema,
    reasons: z.array(MessageFeedbackReasonSchema).max(6).optional(),
  })
  .strict()
  // Mesma invariante do request: motivo só existe no 👎. Um `up` com `reasons`
  // preenchido (doc legado/malformado) é descartado na projeção, não ecoado.
  // Array vazio é aceito — o upsert do `up` persiste `reasons: []`.
  .refine((f) => f.value === 'down' || (f.reasons?.length ?? 0) === 0, {
    message: 'reasons only with value "down"',
  });
export type MessageFeedback = z.infer<typeof MessageFeedbackSchema>;

export type MessageFeedbackList = MessageFeedback[];
